import React from "react";

interface PricingCardProps {
  name: string;
  price: number;
  features: string[];
  isPopular: boolean;
  ctaText: string;
  onSelect: () => void;
}

export default function PricingCard({ name, price, features, isPopular, ctaText, onSelect }: PricingCardProps) {
  return (
    <div className={`relative flex flex-col rounded-2xl border transition-all duration-300 hover:-translate-y-1 hover:shadow-xl ${
      isPopular
        ? "bg-gradient-to-b from-indigo-600 to-purple-700 text-white border-transparent shadow-2xl scale-105"
        : "bg-white border-gray-200 shadow-sm"
    }`}>
      {isPopular && (
        <span className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-amber-400 to-orange-500 text-white text-xs font-bold px-4 py-1.5 rounded-full shadow-md whitespace-nowrap">
          ⭐ Most Popular
        </span>
      )}

      <div className="p-8 flex flex-col flex-1">
        <h3 className={`text-xl font-bold mb-1 ${isPopular ? "text-white" : "text-gray-900"}`}>{name}</h3>
        <div className="mb-6 mt-3">
          <span className={`text-5xl font-extrabold ${isPopular ? "text-white" : "text-gray-900"}`}>
            {price === 0 ? "Free" : `$${price}`}
          </span>
          {price > 0 && <span className={`text-sm ml-1 ${isPopular ? "text-indigo-200" : "text-gray-400"}`}>/month</span>}
        </div>

        <ul className="space-y-3 mb-8 flex-1">
          {features.map((f, i) => (
            <li key={i} className="flex items-start text-sm gap-2.5">
              <svg className={`w-4 h-4 mt-0.5 flex-shrink-0 ${isPopular ? "text-indigo-200" : "text-green-500"}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
              </svg>
              <span className={isPopular ? "text-indigo-100" : "text-gray-600"}>{f}</span>
            </li>
          ))}
        </ul>

        <button
          onClick={onSelect}
          className={`w-full py-3.5 rounded-xl font-bold text-sm transition-all ${
            isPopular
              ? "bg-white text-indigo-700 hover:bg-indigo-50 shadow-lg"
              : "bg-gradient-to-r from-indigo-600 to-purple-600 text-white hover:opacity-90 shadow-md"
          }`}
        >
          {ctaText}
        </button>
      </div>
    </div>
  );
}